import KTLabel, { KTLabelSize } from "general/components/OtherKeenComponents/KTLabel";
import CustomCard from "general/components/Others/CustomCard";
import AppColors from "general/constants/AppColors";
import Utils from "general/utils/Utils";
import useRouter from "hooks/useRouter";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import UIHelper from "general/helpers/UIHelper";
import _ from "lodash";
import AppConstants from "general/constants/AppConstants";
import AgencyReconciliationCardView from "features/ReconciliationReport/SaleReconciliationReport/components/AgencyReconciliationCardView";
import FleetHelper from "features/Fleet/fleetHelper";
import EmptyView from "general/components/Others/EmptyView";
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AppConfigs from "general/constants/AppConfigs";
import KTPagination, { KTPaginationColor } from "general/components/OtherKeenComponents/KTPagination";
import KTTable from "general/components/OtherKeenComponents/KTTable";
import AppRoute from "general/constants/AppRoute";
import tableStyle from "general/components/OtherKeenComponents/KTTable/tableStyle";
import ChargeHelper, { ChargeConstants } from "features/Charge/chargeHelper";
import ChargeTransactionHelper from "features/ManageChargeTransaction/chargeTransactionHelper";
import CustomDropdownMultiChoiceView from "general/components/quybka/Others/CustomDropdownMultiChoiceView";
import KTFormSearch from "general/components/OtherKeenComponents/Forms/KTFormSearch";
import KTBSDropdown from "general/components/OtherKeenComponents/KTBSDropdown";
import ToastHelper from "general/helpers/ToastHelper";

DriverReconciliationDetailView.propTypes = {};

function DriverReconciliationDetailView(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { t } = useTranslation();
    const { reconciliationId } = router.query;
    const agencyId = router?.query?.agencyId;
    const [reconciliationDetail, setReconciliationDetail] = useState(null);
    const [driverDetail, setDriverDetail] = useState(null);
    const [transactionFilter, setTransactionFilter] = useState({
        page: 0,
        limit: AppConfigs.defaultPageLimit,
    });
    const [transactionList, setTransactionList] = useState([]);
    const [transactionTotal, setTransactionTotal] = useState([]);
    const { user } = useSelector((state) => state.auth);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const isOrganizationAgency = useMemo(() => {
        return reconciliationDetail?.agency?.type === 'ORGANIZATION';
    }, [reconciliationDetail]);

    const columns = useMemo(() => {
        return [
            {
                id: 'TRANSACTION_CODE',
                name: UIHelper.buildTableColumn('Mã phiên sạc'),
                selector: (row) => row?.transactionCode,
                minWidth: '110px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'START_TIME',
                name: UIHelper.buildTableColumn('Thời gian bắt đầu'),
                selector: (row) =>
                    row?.startTime ? Utils.formatDateTimeToString(row?.startTime, 'DD/MM/YYYY - HH:mm') : '',
                minWidth: '160px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'END_TIME',
                name: UIHelper.buildTableColumn('Thời gian kết thúc'),
                selector: (row) =>
                    row?.endTime ? Utils.formatDateTimeToString(row?.endTime, 'DD/MM/YYYY - HH:mm') : '',
                minWidth: '160px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'STATUS',
                name: UIHelper.buildTableColumn('Trạng thái'),
                selector: (row) => {
                    return (
                        <KTLabel
                            text={ChargeHelper.Utils.getChargeTransactionStatusName(row?.status)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${ChargeHelper.Utils.getChargeTransactionStatusColor(
                                row?.status
                            )}`}
                            additionalDescription={row?.status === ChargeConstants.ChargeTransactionStatus.CANCELLED ? row?.reason : ''}
                        />
                    );
                },
                minWidth: '180px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'RESERVATION_TIME',
                name: UIHelper.buildTableColumn('Thời gian đặt chỗ'),
                selector: (row) =>
                    row?.reservationEndTime ? Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm') : '',
                minWidth: '160px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'PLATE',
                name: UIHelper.buildTableColumn('Biển số xe'),
                selector: (row) => (
                    <span
                        className={`${Utils.isValid(row?.vehicleId) && _.toNumber(row?.vehicleId) !== 0
                            ? 'cursor-pointer hover-opacity-60'
                            : ''
                            }`}
                        onClick={() => {
                            if (Utils.isValid(row?.vehicleId) && _.toNumber(row?.vehicleId) !== 0) {
                                Utils.openInNewTab(`${AppRoute.vehicleList}/${row?.vehicleId}`);
                            }
                        }}
                    >
                        {Utils.isValid(row?.vehicleId) && _.toNumber(row?.vehicleId) !== 0 ? (
                            row?.plate
                        ) : (
                            <span style={{ color: '#72728B' }}>{row?.plate}</span>
                        )}
                    </span>
                ),
                minWidth: '140px',
                style: tableStyle.columns.link,
            },
            {
                id: 'DRIVER',
                name: UIHelper.buildTableColumn('Tên chủ xe'),
                selector: (row) => (
                    <span
                        className={`${Utils.isValid(row?.user?.userId) && _.toNumber(row?.user?.userId) !== 0
                            ? 'cursor-pointer hover-opacity-60'
                            : ''
                            }`}
                        onClick={() => {
                            if (Utils.isValid(row?.user?.userId) && _.toNumber(row?.user?.userId) !== 0) {
                                Utils.openInNewTab(`${AppRoute.customerList}/${row?.user?.userId}`);
                            }
                        }}
                    >
                        {Utils.isValid(row?.user?.userId) && _.toNumber(row?.user?.userId) !== 0 ? (
                            row?.user?.fullname
                        ) : (
                            <span style={{ color: '#72728B' }}>Vãng lai</span>
                        )}
                    </span>
                ),
                minWidth: '180px',
                style: tableStyle.columns.link,
            },
            {
                id: 'PHONE',
                name: UIHelper.buildTableColumn('Số điện thoại'),
                selector: (row) => row?.user?.phone,
                minWidth: '140px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'VEHICLE_TYPE',
                name: UIHelper.buildTableColumn('Loại phương tiện'),
                selector: (row) =>
                    row?.vehicleType
                        ? _.find(
                            ChargeHelper.Data.vehicleTypeOptions,
                            (item) => item.value === row?.vehicleType
                        )?.name
                        : '',
                minWidth: '130px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'ENERGY',
                name: UIHelper.buildTableColumn('Lượng điện đã sạc', 'kWh'),
                selector: (row) =>
                    Utils.isValid(row?.energy) ? Utils.formatNumber((_.toNumber(row?.energy) / 1000).toFixed(3)) : '',
                minWidth: '140px',
                right: true,
                style: tableStyle.columns.normal,
            },
            {
                id: 'AMOUNT',
                name: UIHelper.buildTableColumn('Số tiền sạc', 'VNĐ'),
                selector: (row) =>
                    row?.status === ChargeConstants.ChargeTransactionStatus.FINISHED
                        ? Utils.formatNumber(
                            row?.totalCost
                        )
                        : Utils.formatNumber(row?.estimatedEnergyCost),
                minWidth: '120px',
                right: true,
                style: tableStyle.columns.normal,
            },
            // {
            //     id: 'PAYMENT_METHOD',
            //     name: UIHelper.buildTableColumn('Đối tượng thanh toán'),
            //     selector: (row) => FleetHelper.Utils.getPaymentMethodTransactionName(row?.paymentMethod),
            //     minWidth: '150px',
            //     right: true,
            //     style: tableStyle.columns.normal,
            // },
            {
                id: 'STATION',
                name: UIHelper.buildTableColumn('Trạm sạc'),
                selector: (row) => (
                    <span
                        className="cursor-pointer hover-opacity-60"
                        onClick={() => {
                            Utils.openInNewTab(
                                `${AppRoute.stationList}/${row?.chargeStation?.stationId ?? ''}`
                            );
                        }}
                    >
                        {row?.chargeStation?.name}
                    </span>
                ),
                minWidth: '200px',
                style: tableStyle.columns.link,
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                width: '100px',
                center: true,
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                cell: (row) => {
                    return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
                },
            },
        ];
    }, []);

    useEffect(() => {
        handleGetReconciliationDetail();
    }, [reconciliationId, agencyId]);

    useEffect(() => {
        handleGetTransactionList();
    }, [reconciliationDetail, transactionFilter]);

    // MARK: ---- METHOD ----

    const buildMoreActions = (row) => {
        const actions = [];
        // xem chi tiet
        actions.push({
            text: 'Xem chi tiết',
            iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
            click: () => {
                router.navigate(`${AppRoute.chargeTransactionList}/${row?.transactionId}`);
            },
        });
        // xuất hóa đơn phiên sạc
        if (adminRole && ChargeTransactionHelper.isFinished(row?.status) && !Utils.isValid(row?.invoiceDocument)) {
            actions.push({
                text: 'Xuất hóa đơn',
                iconElement: <i className="fa-regular fa-file-export" style={{ fontSize: '1.1rem' }} />,
                click: () => {
                    handleCreateInvoice(row)
                },
            });
        }
        return actions;
    };

    const handleGetReconciliationDetail = () => {
        FleetHelper.API.requestGetDriverReconciliationDetail(reconciliationId).then(
            (reconciliationDetail) => {
                setReconciliationDetail(reconciliationDetail);
                setDriverDetail(reconciliationDetail?.driver);
            }
        );
    }

    const handleGetTransactionList = () => {
        if (reconciliationDetail) {
            FleetHelper.API.requestGetDriverChargeSessionsList({
                ...transactionFilter,
                driverId: reconciliationDetail?.driver?.userId,
            }).then(
                (res) => {
                    setTransactionList(res?.chargeSessions);
                    setTransactionTotal(res?.total);
                }
            );
        }
    }

    const handleCreateInvoice = async (row) => {
        const transactionId = row?.transactionId;
        if (!transactionId) return;

        if (Utils.isValid(row?.invoiceSerial) && !Utils.isValid(row?.invoiceDocument)) {
            ToastHelper.showError('Đã xuất hoá đơn nhưng chưa tạo được file PDF');
            return;
        }
        const res = await ChargeHelper.API.ChargeTransaction.requestCreateInvoiceChargeTransaction({
            transactionId,
        });

        if (res && _.isBoolean(res)) {
            ToastHelper.showSuccess('Xuất hóa đơn thành công');
            handleRefresh();
        } else {
            ToastHelper.showError('Xuất hóa đơn thất bại');
        }
    };

    const FleetReconciliationInfo = () => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex align-items-center w-100 p-0">
                    <div className="d-flex flex-column w-100">
                        <div className="d-flex align-items-center gap-2" style={{ overflow: 'hidden' }}>
                            <div
                                className="font-weight-bolder"
                                style={{
                                    color: AppColors.gray[800],
                                    fontSize: Utils.returnFontSize(18),
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {driverDetail?.fullname}{" "}
                                • {driverDetail?.driverCode ?? driverDetail?.driverId}{" "}
                                {driverDetail?.companyCode?.length ? `• ${driverDetail?.companyCode}` : ''}
                            </div>
                        </div>
                        <div style={{ fontSize: Utils.returnFontSize(14), color: AppColors.gray[700] }}>
                            Đối soát tài xế doanh nghiệp kỳ {Utils.formatDateTimeToString(reconciliationDetail?.month, 'MM/yyyy')}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const groupCommissionList = useMemo(() => {
        return [
            {
                name: 'Tổng chi phí sạc',
                value: Math.floor(reconciliationDetail?.totalChargingCost),
                unit: 'VNĐ',
                color: '#30BD6F',
                icon: 'fa-solid fa-badge-dollar',
                show: true,
            },
            {
                name: 'Số tiền tài xế đã chi trả',
                value: Math.floor(reconciliationDetail?.driverPaidAmount),
                unit: 'VNĐ',
                color: '#FE6358',
                icon: 'fa-solid fa-badge-percent',
                show: true,
            },
            {
                name: 'Số tiền doanh nghiệp đã chi trả',
                value: Math.floor(reconciliationDetail?.fleetPaidAmount),
                unit: 'VNĐ',
                color: '#FFAA24',
                icon: 'fa-solid fa-badge-dollar',
                show: true,
            }
        ];
    }, [reconciliationDetail, adminRole, isOrganizationAgency]);

    const FleetReconciliationRevenueInfo = () => {
        return (
            <div
                className="overflow-hidden position-relative mt-4"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '10px',
                }}
            >
                <div
                    style={{
                        backgroundColor: '#fff',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                    }}
                >
                    {/* barchart */}
                    <div className="w-100 d-flex flex-column gap-1 p-4"
                        style={{
                            borderBottom: `1px solid ${AppColors.gray[300]}`
                        }}
                    >
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                            Số liệu tổng quan
                        </div>
                    </div>
                    {/* body */}
                    <div className="w-100 d-flex p-4 gap-3">
                        {groupCommissionList?.filter(cardInfo => cardInfo?.show)
                            ?.map((cardInfo, index) => (
                                <div
                                    key={index}
                                    className="flex-grow-1 p-0"
                                >
                                    <AgencyReconciliationCardView
                                        name={cardInfo.name}
                                        value={cardInfo.value}
                                        unit={cardInfo.unit}
                                        color={cardInfo.color}
                                        icon={cardInfo.icon}
                                        descriptionValue={cardInfo.descriptionValue}
                                        additionalDes={cardInfo?.additionalDes}
                                    />
                                </div>
                            ))}
                    </div>
                </div>
            </div >
        )
    }

    const [selectedChargeStation, setSelectedChargeStation] = useState([]);
    const dropdownStationEl = useMemo(() => {
        return (
            <CustomDropdownMultiChoiceView
                id="stationId"
                name="stationId"
                toggleElement={({ showError }) => (
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                        style={{
                            overflowX: 'auto',
                            overflowY: 'hidden'
                        }}
                        type="button"
                    >
                        {selectedChargeStation?.length > 0 ? selectedChargeStation.map(item => item.name).join(', ') : 'Chọn trạm sạc'}
                    </button>
                )}
                selectedValue={selectedChargeStation}
                dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
                getSubItems={async (item) => {
                    try {
                        return await ChargeHelper.API.requestGetChargeStationList(
                            Utils.filterParams({
                                page: item?.page || 0,
                                limit: 10,
                                q: item?.q || '',
                            })
                        ).then((data) => {
                            return {
                                values: data.chargeStations?.map((station) => ({
                                    id: station?.stationId,
                                    name: station?.name,
                                    item: station,
                                })),
                                total: data.total,
                            };
                        });
                    } catch (error) {
                        console.error('Error fetching station list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeStation(value);
                }}
                onSave={(value) => {
                    transactionFilter = {
                        ...transactionFilter,
                        stationId: value?.length > 0 ? value.map(item => item.id).join(', ') : '',
                        page: 0,
                    };
                    handleGetTransactionList();
                }}
                enableCheckValid
                isDropdownForm={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Trạm sạc',
                    role: 'STATION',
                }}
                idCheckType='id'
            />
        );
    }, [selectedChargeStation]);

    return (
        <div>
            <CustomCard
                showHeader={false}
                additionalClassName="rounded-lg overflow-hidden"
                bgTransparent={true}
                showBorder={false}
                body={
                    <div className="d-flex flex-column">
                        <div
                            className={`col-12 p-0 h-100`}
                        >
                            <FleetReconciliationInfo />

                            <FleetReconciliationRevenueInfo />

                        </div>

                    </div>
                }
            />

            {/* table */}
            <div className="mt-4">
                {UIHelper.buildCard(
                    <div className="p-4">
                        <div className="d-flex flex-column">
                            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                Lịch sử sạc xe của tài xế
                            </span>
                            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                Tổng số:{' '}
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                    {Utils.formatNumber(transactionTotal)} phiên sạc
                                </span>
                            </span>
                        </div>
                        <div className="row m-0 p-0">
                            {/* tim kiem */}
                            <div className="col mb-4 pr-2 pl-0">
                                {UIHelper.buildFormLabel('Tìm kiếm')}
                                <KTFormSearch
                                    name="search"
                                    placeholder="Theo mã phiên sạc, biển số xe, tên chủ xe, số điện thoại, dòng xe..."
                                    value={transactionFilter.q}
                                    onSubmit={(text) => {
                                        transactionFilter = {
                                            ...transactionFilter,
                                            q: text,
                                            page: 0,
                                        };
                                        handleGetTransactionList();
                                    }}
                                />
                            </div>
                            {/* loc theo trang thai */}
                            <div className="col mb-4 px-2">
                                {UIHelper.buildFormLabel('Trạng thái')}
                                <KTBSDropdown
                                    name="status"
                                    toggleElement={
                                        <button
                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                            type="button"
                                        >
                                            {_.find(
                                                ChargeHelper.Data.chargeTransactionStatusOptions,
                                                (item) => item.value === transactionFilter?.status
                                            )?.name ?? 'Tất cả'}
                                        </button>
                                    }
                                    selectedValue={transactionFilter?.status}
                                    dropdownMenuItems={[
                                        { name: 'Tất cả', value: '' },
                                        ...ChargeHelper.Data.chargeTransactionStatusOptions,
                                    ]}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    onChange={(value) => {
                                        transactionFilter = {
                                            ...transactionFilter,
                                            status: value,
                                            page: 0,
                                        };
                                        handleGetTransactionList();
                                    }}
                                    isDropdownForm={true}
                                />
                            </div>
                            {/* loc theo tram sac */}
                            <div className="col mb-4 px-2" style={{ maxWidth: 400 }}>
                                {UIHelper.buildFormLabel('Trạm sạc')}
                                {dropdownStationEl}
                            </div>

                            {/* loc theo loai phuong tien */}
                            <div className="col mb-4 pl-2 pr-0">
                                {UIHelper.buildFormLabel('Loại phương tiện')}
                                <KTBSDropdown
                                    name="vehicleType"
                                    toggleElement={
                                        <button
                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                            type="button"
                                        >
                                            {_.find(
                                                ChargeHelper.Data.vehicleTypeOptions,
                                                (item) =>
                                                    item?.value === transactionFilter?.vehicleType
                                            )?.name ?? 'Tất cả'}
                                        </button>
                                    }
                                    selectedValue={transactionFilter?.vehicleType}
                                    dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.vehicleTypeOptions]}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    onChange={(value) => {
                                        transactionFilter = {
                                            ...transactionFilter,
                                            vehicleType: value,
                                            page: 0,
                                        };
                                        handleGetTransactionList();
                                    }}
                                    isDropdownForm={true}
                                />
                            </div>
                        </div>
                        <div>
                            <KTTable
                                columns={columns}
                                items={transactionList}
                                selectableRows={false}
                                striped={false}
                                compactGrid={false}
                                hasActionColumn={true}
                                onClickedRow={(row) => { }}
                                onSelectedRowsChanged={(rows) => { }}
                                onDoubleClickedRow={(rows) => { }}
                                noDataComponent={
                                    <EmptyView
                                        icon={imgEmptyNoData}
                                        title="Không có dữ liệu để hiển thị"
                                        text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                                    />
                                }
                            />
                            <div className="px-4 mt-2">
                                <KTPagination
                                    currentPage={transactionFilter.page + 1}
                                    rowCount={transactionTotal != 0 ? transactionTotal : transactionList?.length}
                                    rowsPerPage={transactionFilter.limit}
                                    currentItemInPageCount={transactionList?.length}
                                    onChangePage={(newPage) => {
                                        const iNewPage = parseInt(newPage);
                                        setTransactionFilter({
                                            ...transactionFilter,
                                            page: iNewPage - 1,
                                        })
                                    }}
                                    onChangeRowsPerPage={(newRowsPerPage) => {
                                        const iNewRowsPerPage = parseInt(newRowsPerPage);
                                        setTransactionFilter({
                                            ...transactionFilter,
                                            limit: iNewRowsPerPage,
                                            page: 0,
                                        })
                                    }}
                                    color={KTPaginationColor.success}
                                    appendText="công việc"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DriverReconciliationDetailView;
